export function shareToX(url, text) {
  const intent = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  window.open(intent, "_blank", "noopener,noreferrer");
}

export function shareToWhatsApp(url, text) {
  const intent = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
  window.open(intent, "_blank", "noopener,noreferrer");
}

export function shareToInstagram(url) {
  navigator.clipboard.writeText(url);
  return "Link copied! Instagram doesn't support direct link sharing from the web — paste it into your bio or story sticker.";
}
